<template>
    <div id="page">
        <div class="page-content">
            <div class="page-title page-title-small">
                <h2>
                    <button @click.prevent="goBack"><i class="fa fa-arrow-right"></i></button>
                    تابلو اعلانات
                    <button data-menu="HelpMenu" class="position-static mr-1"><i class="fa fa-question-circle helpIco"></i></button>
                </h2>
                <button class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center refresh-btn" @click.prevent="reloadPage"><i class="font-16 fa fa-redo"></i></button>
            </div>
            <div class="card header-card shape-rounded" data-card-height="150">
                <div class="card-overlay bg-highlight opacity-95"></div>
                <div class="card-overlay dark-mode-tint"></div>
                <div class="card-bg bg-20"></div>
            </div>


            <span data-menu="menu-language" class="optionMenu"></span>
            <calendar-filter class="filterCalendar" @selectDate="selectDate"></calendar-filter>

            <div class="card card-style mb-2" v-for="item in NoticeMassageUserList" :key="item.noticeMessageId">
                <div class="py-2 px-3" :id="'Invite-'+item.noticeMessageId">
                    <button data-toggle="collapse" type="button" :data-target="'#collapse-'+item.noticeMessageId" class="no-effect collapsed accordion-btn" aria-expanded="false">
                        <span class="d-flex justify-content-between align-items-center">
                            <span class="d-flex flex-column">
                                <b class="font-15 text-dark">{{item.title}}</b>
                                <span class="font-14 text-muted"><i class="fa fa-hashtag color-blue2-dark ml-3"></i>{{item.code}}</span>
                            </span>
                            <i class="fa fa-angle-up text-muted font-18 accordion-icon fa-rotate-180"></i>
                        </span>
                    </button>
                </div>

                <div class="collapse border-t" :id="'collapse-'+item.noticeMessageId">
                    <div class="d-flex justify-content-between py-3 pr-4 pl-3">
                        <div class="" style="width:90%">
                            <b class="d-block"><i class="fa fa-user color-green2-light ml-3"></i> {{item.creatorUserTitle}}</b>
                            <div class="d-flex justify-content-between">
                                <span><i class="fa fa-calendar color-pink1-dark ml-2"></i> {{item.createDateTimeFa}}</span>
                                <span><i class="fa fa-bullhorn color-magenta2-dark ml-2"></i>{{item.viewDateTimeFa}}</span>
                            </div>
                        </div>
                        <span class="text-left" @click.stop="showMenu(item)" style="width:10%"><i class="fa fa-ellipsis-v font-14"></i></span>
                    </div>
                </div>
            </div>
            <div class="card card-style" v-if="NoticeMassageUserList.length==0 && pageLoading==false">
                <div class="content">
                    <div class="text-center"><i class="fa fa-exclamation-triangle text-warning fa-3x"></i></div>
                    <p class="text-center py-3">هیج موردی یافت نشد.</p>
                </div>
            </div>
            <transition enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutDown">
                <div v-if="pageLoading" class="w-100 d-flex justify-content-center loadingBox">
                    <div class="toast-tiny toast-bottom bg-magenta1-light fade show text-center font-10"><i class="fa fa-sync fa-spin ml-3"></i>درحال ارسال اطلاعات ...</div>
                </div>
            </transition>
            <transition enter-active-class="animated bounceInUp" leave-active-class="animated bounceOutDown">
                <div v-show="pageLoading==false" class="addBtn" id="addBtn" ref="addBtn" :style="{top:addButtonTop}">
                    <router-link to="/NoticeMassageUser" class="btn px-3 py-2  rounded-xl bg-green2-light font-900 text-white shadow-xl border-green2-dark">
                        <i class="fa fa-plus font-14"></i>
                    </router-link>
                </div>
            </transition>
        </div>
        <div id="menu-language" class="menu menu-box-bottom menu-box-detached rounded-m" data-menu-effect="menu-over" style="display: block;">
            <div class="m-3">
                <div class="list-group list-custom-small">
                    <router-link :to="{ name: 'NoticeMassageUserEdit', params: { NoticeMessageId: noticeMassageUserId  } }" class="d-flex justify-content-between align-items-center"><span><i class="fa fa-search color-green2-light float-right font-14"></i>مشاهده</span><i class="fa fa-angle-left"></i></router-link>
                    <button @click="DeleteNoticeMassageUser" class="d-flex justify-content-between align-items-center bg-white p-0"><span class="d-inline-flex align-items-center"><i class="fa fa-trash color-red1-light float-right font-14"></i>حذف</span><i class="fa fa-angle-left"></i></button>
                </div>
                <div class="clear"></div>
            </div>
        </div>
        <Help-Menu title="معرفی موبایل اپلیکیشن تسکینو" keyEn="TaskList"></Help-Menu>
    </div>
</template>

<script>
    import VueSimpleAlert from 'vue3-simple-alert';
    import calendarFilter from '../Components/CalendarFilter.vue';
	import HelpMenu from '../Components/HelpMenu.vue';
    export default {
        components: {
            "calendar-filter": calendarFilter,
			"Help-Menu": HelpMenu
        },
        data() {
            return {
                page: 1,
                filterId: 0,
                searchKey: "",
                mod: false,
                pageLoading: true,
                pageLoaded: false,
                itemID:0,
                date: "",
                noticeMassageUserId:0,
                list: []
            };
        },
        computed: {
            NoticeMassageUserList() {
                return this.list;
            },
        },
        methods: {
            showMenu(t) {
                this.noticeMassageUserId = t.noticeMessageId;
                document.getElementsByClassName("optionMenu")[0].click();
            },
            selectDate(d) {
                this.date = d;
                this.GetNoticeMassageUserList();
            },
            DeleteNoticeMassageUser() {
                document.getElementsByClassName("menu-hider")[0].click();
                VueSimpleAlert.confirm(
                    "آیا مایل به حذف این مورد هستید؟",
                    null,
                    "question",
                    { confirmButtonText: "تایید", cancelButtonText: "انصراف" }
                ).then(() => {
                    this.pageLoading = true;
                    this.$http
                        .get("NoticeMassageUser/Delete?id=" + this.noticeMassageUserId)
                        .then((data) => {
                            var res = data.data;
                            this.pageLoading = false;
                            if (res.isSuccess) {
                                this.GetNoticeMassageUserList();
                            } else {
                                this.showErrorMessage(res.message);
                            }
                        });
                });
            },
            GetNoticeMassageUserList() {
                this.pageLoading = true;
                this.$http
                    .get("NoticeMassageUser/GetList?mode=" + this.mod + "&text=" + this.searchKey + "&date=" + this.date)
                    .then((data) => {
                        var res = data.data;
                        this.list = res;
                        this.pageLoading = false;
                    });

            },
        },
        created() {
            this.GetNoticeMassageUserList();
        },
        mounted() {
            document
                .querySelectorAll(".menu-box-right")
                .forEach((a) => (a.style.display = "block"));
        },
    }
</script>